import React from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {closeDialog} from '../../../slices/dialog';
import {selectSelectedRm} from '../../../slices/selected';
import {editRmGroupMembers} from '../../../api/company/rm';

export const AddToGroup = ({newStudentIds}) => {
    const {register, handleSubmit} = useForm();
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const groups = Object.values(rm?.groups || []);
    const {t} = useTranslation();

    const onSave = form => {
        if (!newStudentIds) dispatch(closeDialog());
        const groupId = form.group;
        const oldStudentIds = rm?.groups[groupId]?.studentIds || [];
        const studentIds = [...new Set([...oldStudentIds, ...newStudentIds])];
        editRmGroupMembers(rm.id, groupId, studentIds).then(() => dispatch(closeDialog()));
    }

    return (
        <div className="addToGroup">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_analytics_addToGroup_name_label")}</div>
                    <select
                        name="group"
                        ref={register({required: true})}
                    >
                        {groups.map(group => <option value={group.id}>{group.name}</option>)}
                    </select>
                </div>
                <input type="submit" value={t("company_rm_analytics_addToGroup_submit")}/>
            </form>
        </div>
    )
}
